import logo from './logo.svg';
import './App.css';

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Hero from "./components/Hero";
import Kontakt from './components/Kontakt'

import Teenused from './components/Teenused'
import TeenusedOrtodontia from './components/Teenused-ortodontia'
import TeenusedOrtodontiaTeens from './components/Teenused-ortodontia-teens'
import TeenusedOrtodontiaLaste from './components/Teenused-ortodontia-laste'

import TeenusedOrtodontiaDiagnostika from './components/Teenused-ortodontia-diagnostika'
import TeenusedOrtodontiaEsteetiline from './components/Teenused-ortodontia-esteetiline'
import TeenusedOrtodontiaPuhastus from './components/Teenused-ortodontia-puhastus'
import TeenusedOrtodontiaReteinerid from './components/Teenused-ortodontia-reteinerid'
import TeenusedOrtodontiaValgendamine from './components/Teenused-ortodontia-valgendamine'

import Lisainfo from "./components/Lisainfo"
import Kliinik from "./components/Kliinik"
import Meeskond from "./components/Meeskond"
import Broneeri from './components/Broneeri'
import Hinnakiri from "./components/Hinnakiri";

import Login from "./components/Adminlogin";
import AdminPanel from './components/Adminpanel';

import {useState, useEffect} from 'react';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function adminLogin() {
  if (localStorage.dev === "1") {
    return (
      
      <div>
        <h1 style={{textAlign:"end"}}>login</h1>
      </div>
    )

    
  }
  return ""
}
function App() {
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  const [text, setText] = useState(null);
  useEffect(() => {
    return
    fetch("https://einblau.ee/backend/api/hinnakiri.php")//https://einblau.ee/backend/api/test.php  https://einblau.ee/backend/api/test.php 
      .then(r => r.text())
      .then(setText);
  }, []);

  return (
    <div className="App">
      <Navbar expand="lg" className="Navbar"> {/* bg-body-tertiary  */}
        <Container>
          <Navbar.Brand href='/'>Blaudent</Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
           <Navbar.Collapse id="basic-navbar-nav">
            <Nav className='me-auto'>
              <Nav.Link href="/">Avaleht</Nav.Link>
              <Nav.Link href="/teenused">Teenused</Nav.Link>
              <Nav.Link href="/hinnakiri">Hinnakiri</Nav.Link>
              <Nav.Link href="/lisainfo">Lisainfo</Nav.Link>
              <NavDropdown title="Meist" id="basic-nav-dropdown">
                <NavDropdown.Item href='/meist/meeskond'>Meeskond</NavDropdown.Item>
                <NavDropdown.Item href='/meist/kliinik'>Kliinik</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="/kontakt">Kontakt</Nav.Link>
            </Nav>
            </ Navbar.Collapse>
        </Container>
      </Navbar>
      <Router>
        <Routes>
          <Route path="/"element={<Hero />}/>

          <Route path="/teenused"element={<Teenused />}/>
          <Route path='/teenused/ortodontia' element={<TeenusedOrtodontia />} />
          <Route path='/teenused/ortodontia-teens' element={<TeenusedOrtodontiaTeens />} />
          <Route path='/teenused/ortodontia-laste' element={<TeenusedOrtodontiaLaste />} />

          <Route path='/teenused/diagnostika' element={<TeenusedOrtodontiaDiagnostika />} />
          <Route path='/teenused/esteetiline' element={<TeenusedOrtodontiaEsteetiline />} />
          <Route path='/teenused/puhastus' element={<TeenusedOrtodontiaPuhastus />} />
          <Route path='/teenused/reteinerid' element={<TeenusedOrtodontiaReteinerid />} />
          <Route path='/teenused/valgendamine' element={<TeenusedOrtodontiaValgendamine />} />

          <Route path="/meist/kliinik" element={<Kliinik></Kliinik>}></Route>
          <Route path="/meist/meeskond" element={<Meeskond></Meeskond>}></Route>

          <Route path="/hinnakiri"element={<Hinnakiri />}/>
          <Route path="/lisainfo" element={<Lisainfo></Lisainfo>}></Route>
          <Route path="/kontakt" element={<Kontakt></Kontakt>} ></Route>

          <Route path="/broneeri" element={<Broneeri></Broneeri>}></Route>

          <Route path='/login' element={ <Login />} />
          <Route path='/admin' element={ <AdminPanel />} />
        </Routes>
      </Router>

          <Container fluid className='footer'>
            <Container>
              <div style={{display:"flex", justifyContent:"space-between", flexWrap:"wrap", flexGrow:"1", paddingTop:"16px", paddingBottom:"24px"}}>
                <div className='footer-item'>
                  <h2>Teenused</h2>
                  <a href='/teenused/ortodontia'>Täiskasvanute Ortondtia</a>
                  <a href='/teenused/ortodontia-teens'>Teens Ortodontia</a>
                  <a href='/teenused/ortodontia-laste'>Laste Ortodontia</a>
                  <a href='/teenused/diagnostika'>Diagnostika</a>
                  <a href='/teenused/esteetiline'>Esteetiline</a>
                  <a href='/teenused/puhastus'>Puhastus</a>
                  <a href='/teenused/valgendamine'>Valgendamine</a>
                </div>
                <div className='footer-item'>
                  <h2>Kasutustingimused</h2>
                  <a href='/failid/isikuandmete-töötlemise-privaatsuspoliitika.pdf'>Privaatsuspoliitika</a>
                  <a href='/failid/KKK.pdf'>KKK</a>
                </div>
                <div className='footer-item'>
                  <h2>Kontakt</h2>
                  <a href='tel:+37255661618'>+372 5566 1618</a>
                  <a href='mailto:info@blaudent.ee'>info@blaudent.ee</a>
                  <h2>Aadress</h2>
                  <a style={{width:"150px"}} href='https://maps.app.goo.gl/tMeF6CiTMx7RUEYC6'>Roopa 12A, Tallinn</a>

                  <p>E 9.00-15.00</p>
                  <p>T 9.00-16.00</p>
                  <p>K 9.00-15.00</p>
                  <p>R üle nädala 9.00-14.00</p>
                </div>
              </div>
            </Container>
          </Container>


    </div>
  );
}

export default App;
// hero bg
//  rgba(28, 77, 140,0.5),
//    rgba(73, 194, 242,0.2)


//hero text
  //rgb(73 194 242)
//rgb(83 127 166)

//
